// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const host = window.location;
// const ApiUrl ;

export const environment = {
  production: false,
  backend: {
    baseURL: "https://threatlabz.webdev.zscaler.com/api"
    // baseURL: host.origin === 'https://d11nxinirezo2k.cloudfront.net' ? 'https://f0rlzwhzfb.execute-api.us-west-2.amazonaws.com/prod/api' : host.origin === 'https://d12981yn7xk356.cloudfront.net' ? 'https://mnt92wmqv9.execute-api.us-west-2.amazonaws.com/staging/api' : host.origin + '/api'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
